export const toEuro = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
});

export const treatmentProgress = (prescriptionStartTime: number) => {
  const now = Date.now();
  const duration = 1000 * 60 * 60 * 24 * 90; // 90 days
  const progress = ((now - prescriptionStartTime) / duration) * 100;
  return {
    progress: Math.min(Math.max(progress, 0), 100), // Clamp to 0-100
    daysLeft: Math.max(0, Math.floor((duration - (now - prescriptionStartTime)) / (1000 * 60 * 60 * 24))),
  };
};
